export const SaleListingAgentDashboardPermissions = {
  SaleListingAgentDashboard: 
    {
      permissionsId:'adf71748-7e1d-4eb1-6833-08da421d6e99',
      permissionsName :'Sale Listing Agent Dashboard',
      componentsId:null,
      components:null , 
    }
} ;
